<template>
  <div :class="bem()">
    <div :class="bem('input-wrapper')">
      <VisionTextInput
        id="search-query"
        v-model:value="query"
        type="text"
        shape="square"
        placeholder="Search for an answer..."
        :class="bem('input')"
        name="searchQuery"
      />
    </div>

    <SupportArticleList
      v-if="query && results.length"
      :category="searchResultsCategory"
      :limit="10"
    />
  </div>
</template>

<script>
import { create, insert, search } from '@orama/orama'
import { debounce } from '~/assets/js/helpers'

export default {
  props: {
    articles: { type: Array, required: true },
  },

  emits: ['toggle'],

  setup () {
    return {
      bem: useBEM('SupportSearch')
    }
  },

  data() {
    return {
      query: null,
      db: null,
      results: []
    }
  },

  computed: {
    searchResultsCategory() {
      return {
        articles: this.results
      }
    }
  },

  watch: {
    async query() {
      await this.search()
    },
  },
  async mounted() {
    this.db = await create({
      schema: {
        title: 'string',
        description: 'string',
        body: 'string'
      }
    })

    for (const article of this.articles) {
      await insert(this.db, article)
    }

    // Debounce search tracker
    this.search = debounce(this.search, 250)
    this.trackSearch = debounce(this.trackSearch, 1000)
  },
  methods: {
    async search () {
      if (!this.query) {
        this.results = []
        return
      }

      const response = await search(this.db, { term: this.query })
      this.results = response.hits.map((hit) => hit.document)
    },
    async trackSearch() {
      if (!this.query) return

      $fetch('/api/v1/support/track_search/', {
        method: 'POST',
        body: {
          query: this.query,
          results: this.searchResults.length
        },
        results: this.searchResults.length,
      }).catch((error) => {
        this.$sentry.captureException(error)
      })

      await this.$track.support.search(this.query, this.searchResults.length)
    },
  },
}
</script>

<style lang="postcss">
.SupportSearch {
  @apply flex flex-col gap-4;
}
</style>
